import React, {FC, useState} from 'react';
import { useTranslation } from 'react-i18next';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import PlusIconWhite from '../../../assets/icons/plus-icon.svg';
import PlusIconPrimary from '../../../assets/icons/plus-icon-primary.svg';
import PrimaryButton from '../../buttons/primaryButton';
import { Colors } from '../../../constants/constants';

interface DashboardSubMenuProps {
  openNewElementDialog: () => void,
  openNewDashboardDialog: () => void,
}
const DashboardSubMenu: FC<DashboardSubMenuProps> = (props) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <PrimaryButton
        type="button"
        onClick={handleClick}
        className="flex items-center gap-2.5 h-[40px] ml-5 px-5"
        style={{
          backgroundColor: open ? '' : '#ECECEC',
          outline: open ? '' : `1px solid ${Colors.primary}`,
          color: open ? '' : Colors.primary,

        }}
        dataCy="dashboard-actions-open-dashboard-submenu"
      >
        {open ? <img src={PlusIconWhite} alt="" /> : <img src={PlusIconPrimary} alt="" />}
        {t('new')}
      </PrimaryButton>
      <Menu
        anchorEl={anchorEl}
        id="dashboard-menu"
        open={open}
        onClose={() => setAnchorEl(null)}
        onClick={() => setAnchorEl(null)}
        sx={{ zIndex: 1306 }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& ul': {
              paddingBlock: '4px',
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              right: 20,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-40%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={props.openNewElementDialog}>
          {t('addElement')}
        </MenuItem>
        <hr className="my-1" />
        <MenuItem onClick={props.openNewDashboardDialog}>
          {t('addDashboard')}
        </MenuItem>
      </Menu>
    </>
  );
};

export default DashboardSubMenu;
